module.exports = "https://static.im-cdn.com/mjc/storefront/Compass/static/media/plus.d8a7ffac.svg";